









































import Vue from 'vue'
import { apiBlindBoxOrderRecover } from '@/api'
import { boxBus } from '../bus'
import { navigateTo, redirectTo } from '@/router'
import { submit } from '@/utils'

export default Vue.extend({
  model: {
    prop: 'visible',
    event: 'change',
  },

  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    goods: {
      type: Object,
      required: true,
    },
    orderId: {
      type: String,
      required: true,
    },
    redirect: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isVisible: {
      get(): boolean {
        return this.visible
      },
      set(visible: boolean) {
        this.$emit('change', visible)
      },
    },
  },

  methods: {
    handleCancelClick() {
      this.isVisible = false
    },

    handleConfirmClick() {
      submit(async $ => {
        $.start()
        await apiBlindBoxOrderRecover({
          id: this.orderId,
        })
        boxBus.emit('shouldRefreshOrderList')
        this.isVisible = false
        if (this.$listeners.refresh) {
          this.$emit('refresh')
        }
        this.$nextTick(() => {
          if (this.redirect) {
            redirectTo('BoxRefundResult', {
              orderId: this.orderId,
            })
          } else {
            navigateTo('BoxRefundResult', {
              orderId: this.orderId,
            })
          }
        })
      })
    },
  },
})
